export const ActionTypes = {
  LOADING: "REMOVE_FROM_FINALIST_LOADING",
  ERROR: "REMOVE_FROM_FINALIST_ERROR",
  SUCCESS: "REMOVE_FROM_FINALIST_SUCCESS",
};
